let authErrorCallback: (() => void) | null = null;

export const setAuthErrorCallback = (callback: () => void) => {
    authErrorCallback = callback;
};

export const triggerAuthError = () => {
    if (authErrorCallback) {
        authErrorCallback();
    }
};

